import { render, staticRenderFns } from "./header-cart.vue?vue&type=template&id=390c00d3"
import script from "./header-cart.vue?vue&type=script&lang=js"
export * from "./header-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports